<template>
<div class="collapse navbar-collapse w-auto h-auto h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
        <li class="nav-item">
            <sidenav-item url="/panel" navText="Panel">
                <template v-slot:icon>
                    <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
                </template>
            </sidenav-item>
        </li>
        <li class="nav-item">
            <sidenav-item url="/profil" navText="Profil">
                <template v-slot:icon>
                    <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
                </template>
            </sidenav-item>
        </li>
        <li class="mt-3 nav-item">
            <h6 class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 ms-2">
                SERWER
            </h6>
        </li>
        <li class="nav-item">
            <sidenav-item url="/kary" navText="Lista kar">
                <template v-slot:icon>
                    <i class="ni ni-calendar-grid-58 text-danger text-sm opacity-10"></i>
                </template>
            </sidenav-item>
        </li>
    </ul>
</div>
<!-- <div class="pt-3 mx-3 mt-3 sidenav-footer">
    <sidenav-card :class="cardBg" textPrimary="Need Help?" textSecondary="Please check our docs" />
</div> -->
</template>

<script>
import SidenavItem from "./SidenavItem.vue";
// import SidenavCard from "./SidenavCard.vue";

export default {
    name: "SidenavList",
    props: {
        cardBg: String
    },
    data() {
        return {
            title: "Argon Dashboard 2",
            controls: "dashboardsExamples",
            isActive: "active"
        };
    },
    components: {
        SidenavItem,
        // SidenavCard
    },
    methods: {
        getRoute() {
            const routeArr = this.$route.path.split("/");
            return routeArr[1];
        }
    }
};
</script>
